import { Pipe, PipeTransform } from '@angular/core';
import {AssetsService} from '../services/assets.service';
import {ImgEnum} from '../models/assets.model';

@Pipe({
  name: 'imageSrc',
  standalone: false
})
export class ImageSrcPipe implements PipeTransform {
  
  constructor(private assetsService: AssetsService) {
  }
  
  transform(imageName: ImgEnum): string {
    if (!imageName) {
      return imageName;
    }
    
    const imageSrc = this.assetsService.getAssetSource(imageName);
    return !!imageSrc ? imageSrc : '' ;
  }

}
